<template>
      <v-dialog
          transition="dialog-bottom-transition"
          max-width="800"
          :value="value"
          scrollable
          >
          <v-card
              v-if="endpointData"
          >
            <v-toolbar
                color="secondary"
                dark
                class="text--primary"
            >
              <v-btn icon color="primary" @click="onClose">
                <v-icon>fa-window-close</v-icon>
              </v-btn>
              <v-toolbar-title class="primary--text">
                {{ endpoint.name }} | {{ endpoint.endpoint_flavor.name }} | Serverantwort vom {{ formattedDateTime(endpointData.created_at) }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-icon color="primary"
               @click="onDownload"> mdi-download </v-icon>
            </v-toolbar>
              <v-card-text>
                <pre class="py-5">{{ prettyPrinted }}</pre>
              </v-card-text>
          </v-card>
      </v-dialog>
</template>

<script>
import vkbeautify from "vkbeautify";
import timeformatter from "@/utils/timeformatter";

export default {
  name: "ResponseDetails",
  props: ['value', 'endpoint', 'endpointData', 'is_direct'],
  methods: {
    onClose() {
      this.$emit('close')
    },
    onDownload() {
      if(this.isDirectEndpoint) {
        this.$emit('direct-download')
      } else {
        this.$emit('download', this.endpointData)
      }
    },
    formattedDateTime(date) {
      return timeformatter.format(date)
    }
  },
  computed: {
    isDirectEndpoint () {
      return this.endpoint && this.endpoint.direct
    },
    prettyPrinted () {
      if (this.endpoint && this.endpoint.expected_format && this.endpointData) {
        switch (this.endpoint.expected_format) {
          case 'xml':
            try {
              return vkbeautify.xml(this.isDirectEndpoint ? this.endpointData : this.endpointData.response)
            }
            catch (e) {
              return this.isDirectEndpoint? this.endpointData : this.endpointData.response
            }
          case 'json':
            try {
              return vkbeautify.json(this.isDirectEndpoint ? this.endpointData : this.endpointData.response)
            }
            catch (e) {
              return this.isDirectEndpoint? this.endpointData : this.endpointData.response
            }
          default:
            return this.isDirectEndpoint? this.endpointData : this.endpointData.response
        }
      }
      return ''
    }
  }
}
</script>
<style scoped>
.v-toolbar__title {
  font-size: 18px !important;;
  color: #D22321;
  font-weight: bold;
}
</style>